import { render, staticRenderFns } from "./goodsAttributesChange.vue?vue&type=template&id=1011df4a&scoped=true"
import script from "./goodsAttributesChange.vue?vue&type=script&lang=js"
export * from "./goodsAttributesChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1011df4a",
  null
  
)

export default component.exports